export default "__VITE_ASSET__ce60a406__"